import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { localeAwareFormatDistance } from 'app/lib/date';
import { useTranslation } from 'react-i18next';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconClock } from '@tabler/icons-react-native';
import { theme } from './shared';

export function ProfilePresence({
  isUnavailable,
  lastSeenAt,
  trustPoints,
}: {
  isUnavailable: boolean;
  lastSeenAt?: string | null;
  trustPoints?: number;
}) {
  const { t } = useTranslation();
  if (isUnavailable) {
    return (
      <Row alignItems="center" gap="spacing.general.x1">
        <IconClock strokeWidth={ICON_STROKE_WIDTH} size={18} color={theme.colors['text.placeholder']} />
        <Text color="text.secondary" variant="bodyBase">
          {t('currentlyUnavailable', { ns: 'neighbour-profile' })}
        </Text>
      </Row>
    );
  }
  if (!trustPoints && !lastSeenAt) return null;
  return (
    <Text color="text.placeholder" numberOfLines={1} variant="bodyBase">
      {trustPoints ? `👍 (${trustPoints.toFixed(0)})` : ''}
      {trustPoints && lastSeenAt ? ' · ' : ''}
      {lastSeenAt
        ? t('lastActiveAgo', {
            ago: localeAwareFormatDistance(new Date(), new Date(lastSeenAt)),
            ns: 'common',
          })
        : ''}
    </Text>
  );
}
